import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { PetProvider } from './contexts/PetContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Toaster } from './components/ui/sonner';

import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ChoosePetPage from './pages/ChoosePetPage';
import DashboardPage from './pages/DashboardPage';
import ScanPage from './pages/ScanPage';
import BuddyPublicPage from './pages/BuddyPublicPage';
import GlobalNarrator from './components/GlobalNarrator';
import AuthCallback from './components/AuthCallback';

import './App.css';

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user && user !== false) return <Navigate to="/dashboard" replace />;
  return <LandingPage />;
}

// Synchronous check for the Emergent-Auth callback fragment.
// Detecting it in the render pass (not useEffect) prevents ProtectedRoute
// from racing us and redirecting to /login before we can exchange the
// session_id for cookies.
function AppRouter() {
  const location = useLocation();
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<RootRedirect />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ForgotPasswordPage />} />
      <Route path="/scan/:taskId" element={<ScanPage />} />
      <Route path="/buddy/:token" element={<BuddyPublicPage />} />
      <Route
        path="/choose-pet"
        element={
          <ProtectedRoute>
            <ChoosePetPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider>
        <AuthProvider>
          <PetProvider>
            <AppRouter />
            <Toaster position="top-center" richColors />
            <GlobalNarrator />
          </PetProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;
